import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { ActionFunctionArgs, data, useLoaderData } from "react-router";

import OnboardingActionsSection from "@/components/Onboarding/OnboardingActionsSection";
import OnboardingResourcesSection from "@/components/Onboarding/OnboardingResourcesSection";
import Progresses from "@/components/Onboarding/Progresses";
import Card from "@/components/ui/Card";
import { TProgressData } from "@/types";

export async function loader() {
  const progressResponse = await fetch(`/api/client/onboardings/progress_data`);

  if (progressResponse.status !== 200) {
    throw data("Failed to load progress data", {
      status: progressResponse.status,
    });
  }

  const { data: onboarding } = (await progressResponse.json()) as {
    data: TProgressData;
  };

  return {
    progressData: onboarding,
  };
}

export async function action({ request }: ActionFunctionArgs) {
  const data = await request.formData();
  const actionKey = data.get("actionKey") as string;

  const skipActionResponse = await fetch(
    `/api/client/skip_onboarding_action/${actionKey}`,
    {
      method: "POST",
    }
  );

  if (skipActionResponse.status !== 200) {
    return { ok: false };
  }

  return { ok: true };
}

function Onboarding() {
  const { t } = useTranslation("onboarding");
  const { progressData } = useLoaderData<typeof loader>();

  return (
    <div className="mx-xl my-lg">
      <Typography step="3" as="h1" weight="bold" className="mb-sm">
        {t("title")}
      </Typography>
      <div className="gap-md grid grid-cols-3">
        <OnboardingActionsSection />
        <Card className="col-span-3 lg:col-span-1">
          <div className="flex items-baseline justify-between">
            <Typography step="2" as="h2" weight="bold" className="mb-sm">
              {t("collect.title")}
            </Typography>
          </div>
          <Progresses progressData={progressData} />
        </Card>
        <OnboardingResourcesSection />
      </div>
    </div>
  );
}

export default Onboarding;
